import { createFileRoute, Outlet } from "@tanstack/react-router";
import i18n from "i18next";
import { useFeatureFlags } from "~/contexts/FeatureFlagContext";
import { NotFound } from "~/pages/NotFound";

export const Route = createFileRoute("/_app/search-terms")({
  head: () => ({ meta: [{ title: i18n.t("general:header.searchTerms") }] }),
  component: SearchTermsRoute,
});

function SearchTermsRoute() {
  const { features } = useFeatureFlags();

  return features.useFeSearchTerms ? <Outlet /> : <NotFound />;
}
